module.exports = __webpack_public_path__ + "img/tab_item_def.bab23182.png";